import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { SessionProvider } from '@/entities/session';
import { supabase } from '../shared/api/supabase';
import { i18n } from '../shared/i18n';
import { initSentry } from '../shared/observability/sentry';
import { Toaster } from '../shared/ui/sonner';
import { TooltipProvider } from '../shared/ui/tooltip';
import { I18nProvider } from './providers/i18n';
import { QueryProvider } from './providers/query';
import { router } from './router';
import './styles.css';

initSentry();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');
createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <Sentry.ErrorBoundary fallback={<p>{i18n.t('somethingWentWrong')}</p>}>
        <SessionProvider client={supabase}>
          <QueryProvider>
            <TooltipProvider>
              {/* the router catches render errors itself, so the boundary above never sees them */}
              <RouterProvider router={router} onError={(error) => Sentry.captureException(error)} />
              <Toaster />
            </TooltipProvider>
          </QueryProvider>
        </SessionProvider>
      </Sentry.ErrorBoundary>
    </I18nProvider>
  </StrictMode>,
);
